import { Input } from "design-react-kit";
import { useContext } from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../Components/Loader";
import Select from "../../Components/Select";
import { TokenContext } from "../../Components/TokenContext";
import Repo from "../../Utility/Repo";
import LabelsLoader  from "../../Utility/labelsLoader";

function Help(props) {
  const apiToken = useContext(TokenContext);
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [validation, setValidation] = useState();
  const [validationEmail, setValidationEmail] = useState();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioSelected, setServizioSelected] = useState();

  const changeServizio = (event) => {
    var nameEvent = event.label;
    setServizioSelected({ label: nameEvent });
  };
  const labels = LabelsLoader();
  const [messageSend, setMessageSend] = useState({
    emailUser: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    getServiziAPI();
    getUserAPI();
  }, []);

  useEffect(() => {
    if (messageSend != null) {
      const timer = setTimeout(() => {
        setIsAlertVisible(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isAlertVisible, messageSend]);

  useEffect(() => {
    const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if (messageSend.email && !messageSend.email.match(regexEmail)) {
      setValidationEmail(false);
    } else {
      setValidationEmail(true);
    }
  }, [messageSend.email]);

  // const messageValidation = () => {
  //   setValidation(true);
  //   let passedValidation = true;

  //   Object.entries(messageSend).map(([key, value]) => {
  //     //isArray is used to exclude the isees array in the validation
  //     if (value == "" || value == null) {
  //       passedValidation = false;
  //     }
  //   });

  //   if (passedValidation) {
  //     sendMessageAPI();
  //   }
  // };
  const messageValidation = () => {
    if (messageSend) {
      sendMessageAPI();
    } else {
      console.log("errore");
    }
  };

  const sendMessageAPI = () => {
    setLoading(false);
    Repo.postEmail(apiToken, JSON.stringify(messageSend))
      .then((response) => {
        if (response.status == 200) {
          setLoading(true);
          setIsAlertVisible(true);

          setMessageSend({
            emailUser: "",
            subject: servizioSelected,
            message: "",
          });
          setValidation();
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const getServiziAPI = () => {
    setLoading(false);
    Repo.getUserServices(apiToken)
      .then((response) => {
        let tempArray = [];
        response.data.map((x, index) => {
          let temp = {
            label: "",
            value: "",
          };
          temp["label"] = x.name;

          tempArray.push(temp);
        });

        tempArray.push({
          label: "Altro",
          value: "Altro",
        });
        setServizi(tempArray);

        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const getUserAPI = () => {
    setLoading(false);
    Repo.getUser(apiToken)
      .then((response) => {
        setUser(response.data);

        if (response.data.email) {
          setMessageSend({
            ...messageSend,
            emailUser: response.data.email,
          });
        }

        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  return (
    <>
           <h1>{labels.Supporto}</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>{labels.aiuto}</p>
          </div>


      <div className="row mb-4" style={{ borderBottom: "1px solid #80808073" }}>
        <div className="col-lg-12">

          <div className="row mb-5">
            <div className="col-12">
              <Link
                to="/doc/Manuale.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Visualizza manuale
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row ">
        <div className="col-lg-12 mb-5 pb-5">
          <h5>Hai una segnalazione da effettuare?</h5>
          <p>
            <strong>Utilizza il form contatti di seguito:</strong>
          </p>
          <div className="card-wrapper px-lg-5">
            <div className="card card-bg card-big roundedCustom no-after ">
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-12">
                    <Input
                      id="email"
                      label="Email*"
                      type="text"
                      name="email"
                      value={messageSend.emailUser}
                      onChange={(e) =>
                        setMessageSend({
                          ...messageSend,
                          emailUser: e.target.value,
                        })
                      }
                      {...(validation &&
                        !messageSend.emailUser && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger",
                        })}
                      {...(messageSend.emailUser &&
                        !validationEmail && {
                          infoText: "Il formato della mail non è corretto!",
                          className: "text-danger",
                        })}
                    />
                  </div>
                  <div className="col-lg-12">
                    <Select
                      aria-label="Argomento"
                      clearText="Annulla"
                      defaultMenuIsOpen={false}
                      icon={false}
                      name="subject"
                      id="subject"
                      onChange={changeServizio}
                      options={servizi}
                      isSearchable
                      placeholder={servizi ? servizi.label : "Seleziona"}

                      // onChange={(e) =>
                      //   setMessageSend({
                      //     ...messageSend,
                      //     subject: e.target.value,
                      //   })
                      // }
                    />
                  </div>
                  <div className="col-lg-12 mt-3">
                    <p>Descrizione:</p>
                    <textarea
                      id="message"
                      label="Descrizione*"
                      type="text"
                      name="message"
                      rows="5"
                      cols="50"
                      maxLength="400"
                      value={messageSend.message}
                      onChange={(e) =>
                        setMessageSend({
                          ...messageSend,
                          message: e.target.value,
                        })
                      }
                    />
                    {validation && !messageSend.message && (
                      <p>Il campo non può essere vuoto!</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="card-footer ">
                <div className="row">
                  <div className="col-12  text-right">
                    <button
                      onClick={messageValidation}
                      className="btn btn-primary"
                    >
                      Invia
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isAlertVisible && (
        <>
          <div
            className="alert alert-success"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "30%",
              zIndex: 10000,
            }}
          >
            <b>
              Segnalazione avvenuta con successo, risponderemo alla mail
              indicata!
            </b>
          </div>
        </>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
}

export default Help;
